import { Grid, Tooltip, Typography } from '@material-ui/core';
import { Close, Create } from '@material-ui/icons';
import React, { useState } from 'react';
import TaskPicker from './TaskPicker';

const TaskInput = ({
  entry,
  onChange,
  disabled,
  preFilter,
  helperText,
  error,
  ...props
}) => {
  const [showPicker, setShowPicker] = useState(false);

  if (!entry) return '';
  return (
    <div style={{ marginTop: 16 }}>
      {showPicker && (
        <TaskPicker
          onSelect={(task) => {
            onChange(task);
            setShowPicker(false);
          }}
          onClose={() => setShowPicker(false)}
        />
      )}
      <Grid
        style={{ cursor: 'pointer' }}
        container
        onClick={() => {
          if (!disabled) {
            setShowPicker(true);
          }
        }}
      >
        <Grid
          item
          xs={11}
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Tooltip title={entry.companyName || 'Select a task...'}>
            {entry.companyName ? (
              <Typography variant="caption" color="primary">
                {entry.companyName || 'Select a task...'}
              </Typography>
            ) : (
              <Typography color="primary">Select a task...</Typography>
            )}
          </Tooltip>
          {error && (
            <Typography style={{ paddingTop: 4, color: 'red', fontSize: '0.75rem' }}>{helperText}</Typography>
          )}
        </Grid>
        <Grid style={{ display: 'flex' }} item xs={1}>
          <Create fontSize="small" color="disabled" />
          <Close
            fontSize="small"
            color="disabled"
            onClick={(e) => {
              if (!disabled) onChange(null);
              e.stopPropagation();
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Tooltip title={entry.incidentName || ''}>
            <Typography variant="caption">{entry.incidentName}</Typography>
          </Tooltip>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Tooltip title={entry.taskName || ''}>
            <Typography>{entry.taskName}</Typography>
          </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
};

export default TaskInput;
